import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GlobalProvider } from "../global/global";

/*
  Generated class for the LoginProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LoginProvider {
  headers: any;

  constructor(public http: HttpClient, public global: GlobalProvider) {
    this.headers = new HttpHeaders().set("Content-Type", "application/json");
  }

  login(u, c) {
    //usuario de Pruebas:  Paula

    /* var parametros = {
      "u": u,
      "k": p_encrypted,
      "t" :eltoken
    }*/

    let parametros = this.global.calcula_ukt(u, c);

    let url = this.global.URLBASEJSON + "login";

    let params = new HttpParams();
    params = params.append("u", parametros.u);
    params = params.append("k", parametros.k);
    params = params.append("t", parametros.t);

    return this.http.post(url, params, this.headers);
  }

  registrarApp(usuario, PregId, PuuId, Plataforma) {
    /*
    let url = this.global.URLBASEJSON 

    if(Plataforma =="android"){
      url += 'registrar-gcm'
    } else if(Plataforma =="ios" ) {
      url += 'registrar-apns'
    }
    console.log("registrarapp url:",url)
    console.log("registrarapp idusuario:",usuario," regid:",PregId," uuid:",PuuId)

    let params = new HttpParams();
    params = params.append('idusuario', usuario);
    params = params.append('regid', PregId);
    params = params.append('uuid', PuuId);

    return this.http.post(url,params,this.headers)           
    
 */
  } // fin registrar
}



// WEBPACK FOOTER //
// ./src/providers/login/login.ts